import { ApiConstants } from "../../constants/ApiConstants";
import { NOTIFICATION_GET } from "../Constants/NotificationConstants";
import { createPostDataAction } from "./CommonAction";



export const NotificationGetAction = (payload: any) => createPostDataAction(NOTIFICATION_GET, ApiConstants?.NotificationGet, payload, false);
